import React from 'react';
import classNames from 'classnames';

import 'scss/layout.scss';
import './index.scss';

export default function WorkflowPanel({className, buttons, sameSizeButtons, children}) {
    const classes = classNames('layout-stack', 'workflow-panel', className, {
        'workflow-panel--same-size-buttons': sameSizeButtons
    });
    return (
        <div className={classes}>
            <div className="layout-stack workflow-panel__main">{children}</div>
            <div className="workflow-panel__buttons">{buttons}</div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./components/workflow_panel/index.js